module.exports = __webpack_public_path__ + "static/media/c-asian.220cea8e.jpg";